import supabase from "../../../shared/database/supabase";
import { ServiceOrderRepository } from "../../../models/service-order/service-order.repository";

export interface updateServiceOrderStatusParams {
    serviceOrderId: string;
    finishedBy: string;
    finished: boolean;
}

export const updateServiceOrderStatus = async (params: updateServiceOrderStatusParams) => {
    try {
        const { data, error } = await supabase.functions.invoke<ServiceOrderRepository>("update-service-order-status", {
            body: JSON.stringify({
                service_order_id: params.serviceOrderId,
                finished_by: params.finished ? params.finishedBy : null,
                finished: params.finished,
            }),
        });

        if (error) {
            console.error("Error calling update-service-order-status:", error);
            return { data: null, error };
        }
        return { data: data, error: null };
    } catch (err) {
        console.error("Exception in updateServiceOrderStatus:", err);
        throw err;
    }
};